///include /assets/js/plugins/domain_categories.js

"use strict"
// A dac concroller

if(typeof window.appPrefix == "undefined") {
    window.appPrefix = location.href.match(/20i[.]com/) ?
        "https://my.20i.com" :
        ""
}


/**
 * @typedef domainProductIn
 * @property {string} code
 * @property {{[type: string]: {[interval: string]: {[pricingType: string]: {setup: string, purchase: string}}}}} pricing
 */

class DACDomainProduct {
    /**
     *
     * @param {domainProductIn} result
     */
    constructor(result, domainStore) {
        this.code = result.code
        this.pricing = result.pricing
        this.domainStore = domainStore
    }
    get anyPrice() {
        let p = this.pricing
        for(let type in p) {
            for(let interval in p[type]) {
                return p[type][interval][this.domainStore.pricingType]
            }
        }
        return null
    }
    /**
     *
     * @param {number} year
     * @param {?number} [discovered_price]
     * @return {number}
     */
    priceForYears(year, discovered_price = null) {
        return Math.round(
            (
                +this.anyPrice.setup +
                year * (discovered_price || +this.anyPrice.purchase)
            ) * 100
        ) / 100
    }
}

class DomainResult {
    get productTLDs() {
        if(this.domainStore.productByTld) {
            return Object.keys(this.domainStore.productByTld).sort(
                (a, b) => b.length - a.length
            )
        } else {
            return []
        }
    }
    /**
     *
     * @param {string} name
     * @param {AnyDomainStore} domainStore
     * @param {AnyBasketInst} basketClient
     */
    constructor(name, domainStore, basketClient, defaultYears = 2) {
        this.basketItem = null
        this.name = name
        this.status = new DRStatusInitial()
        this.domainStore = domainStore
        this.basketClient = basketClient
        this.defaultYears = defaultYears
        this.hidden = false

        if (domainStore && domainStore.catalogue && domainStore.catalogue.products) {
            const tldProduct = domainStore.catalogue.products.find(p => p.tld && p.tld === this.tld)
            if (tldProduct) {
                this.hidden = !!tldProduct.hidden;
            }
        }
    }
    get basketItemStructure() {
        var structure = {
            add: [
                `${this.status.product.code}/${this.name}`
            ],
            price: +(this.status.discoveredPrice * this.selected_years).toFixed(2),
            quantity: {
                [this.name]: this.selected_years
            },
            configuration: {
                assignDefaultNameservers:
                    +(this.status.can.match(/^transfer/)),
            },
            status: this.status.can
        };
        if( this.status.can.match("^premium") ){
            structure.configuration.premium_price_to_verify = +(this.status.discoveredPrice * this.selected_years).toFixed(2);
        }
        return structure;
    }
    /**
     * @type {AnyBasketItemInst}
     */
    get basketItem() {
        return this._basketItem
    }
    set basketItem(v) {
        if(this.status) {
            this.status.in_basket = !!v
        }
        this._basketItem = v
    }
    /**
     * @type {string}
     */
    get label() {

        if(this.basketItemRef) {
            return "Added"


        } else {
            return this.status.displayInfo.label
        }
    }
    get loading_data() {
        return !!this.status.loading
    }
    /**
     * @type {boolean}
     */
    get mayAddToBasket() {
        return !this.basketItem && !!this.status.can
    }
    get nameWithoutTld() {
        return this.name.replace(/[.].*/, "")
    }
    get pricingOptions() {
        if(
            this.status && this.status.can && this.status.can.match("transfer") &&
            this.status.pricing &&
            this.status.pricing.length == 1 &&
            this.status.pricing[0].value == "1"
        ) {
            return [{
                text: `Transfer for ${this.status.transferPriceLabel}`,
                id: this.status.pricing[0].value
            }];
        } else if(this.status.pricing) {
            return this.status.pricing
        } else {
            return []
        }
    }
    /**
     * @type {number}
     */
    get selected_years() {
        if(this._selected_years) {
            return this._selected_years
        } else {
            if(this.status.pricing) {
                if(
                    !this.status.discoveredPrice &&
                    this.status.pricing.find(i => +i.value == this.defaultYears)
                ) {
                    this._selected_years = this.defaultYears
                } else {
                    this._selected_years = 1
                }
                return this._selected_years
            } else {
                return 1
            }
        }
    }
    set selected_years(v) {
        this._selected_years = v
    }
    /** @type {DRStatusGeneral} */
    get status() {
        return this._status
    }
    set status(v) {
        if(v.can == "suggestion" && this._status) {
            //
        } else if(
            this._status &&
            v.constructor == this._status.constructor &&
            v.can == this._status.can
        ) {
            //
        } else {
            this._status = v
        }
    }
    get tld() {
        return this.name.replace(/^[^.]*/, '')
    }
    /**
     * @param {boolean} [silent]
     * @returns {Promise<*>}
     */
    async addToBasket(silent = false) {
        if(!this.status.canBuy) {
            alert(`${this.name} ${this.status.title}`)
            return null
        } else {
            try {
                await this.basketClient.addItem(
                    this.basketItemStructure,
                    true
                )
                this.status.checked = false
            } finally {
                this.basketClient.reloadContent(silent)
            }
        }
    }
    /**
     *
     * @param {(r: DomainResult) => void} f
     */
    async checkDetailed(f) {
        this.status = new DRStatus(
            {
                header: null,
                can: "recheck",
                name: this.name,
                expiryDate: null,
                hasRight: null,
                maxYears: null,
                price: null,
                push_transfer_registrar: null,
                startsNewPeriod: null,
            },
            this.domainStore,
            this.basketClient
        )
        try {
            const data = await $.ajax({
                method: "get",
                url: `${appPrefix}/a/domain-search/${this.name}`
            })
            const p = data[1]
            this.status = new DRStatus(
                (p.can && p.can.match(/^transfer-?/)) ?
                    p :
                    {
                        can: null,
                        name: this.name,
                    },
                this.domainStore,
                this.basketClient
            )
            this.status.ranDetailedCheck = true
            f(this)
        } catch(e) {
            console.log(`Detail check error for ${this.name}`)
            this.status =
                new DRStatus(
                    {
                        header: null,
                        can: null,
                        name: this.name,
                        expiryDate: null,
                        hasRight: null,
                        maxYears: null,
                        price: null,
                        push_transfer_registrar: null,
                        startsNewPeriod: null,
                    },
                    this.domainStore,
                    this.basketClient
                )
        }
    }
}

class DRStatusGeneral {
    constructor() {
        /** @type {?boolean} */
        this.checked = null
        /** @type {?boolean} */
        this.in_basket = null
        /** @type {?boolean} */
        this.ranDetailedCheck = null
    }
    /** @type {?string} */
    get can() {
        throw new Error("Unimplemented")
    }
    /** @type {?boolean} */
    get canBuy() {
        throw new Error("Unimplemented")
    }
    /** @type {?string} */
    get can_class() {
        throw new Error("Unimplemented")
    }
    /** @type {?boolean} */
    get connected_to_registrar() {
        throw new Error("Unimplemented")
    }
    /** @type {?boolean} */
    get disabled() {
        throw new Error("Unimplemented")
    }
    /** @type {?boolean} */
    get disableLock() {
        throw new Error("Unimplemented")
    }
    /** @type {?number} */
    get discoveredPrice() {
        throw new Error("Unimplemented")
    }
    /** @type {{displayClass: string | string[] | null, label: ?string, labelDisplayClass: ?string, title: ?string}} */
    get displayInfo() {
        throw new Error("Unimplemented")
    }
    /** @type {?boolean} */
    get isFinal() {
        return null
    }
    /** @type {?string} */
    get label_class() {
        throw new Error("Unimplemented")
    }
    /** @type {boolean} */
    get loading() {
        return null
    }
    /** @type {?{setup: string, purchase: string}} */
    get mainPrices() {
        throw new Error("Unimplemented")
    }
    /** @type {?boolean} */
    get needsDetailCheck() {
        throw new Error("Unimplemented")
    }
    /** @type {?{text: string, value: string}[]} */
    get pricing() {
        throw new Error("Unimplemented")
    }
    /** @type {?DACDomainProduct} */
    get product() {
        throw new Error("Unimplemented")
    }
    /** @type {?string} */
    get productTLD() {
        throw new Error("Unimplemented")
    }
    /** @type {string | string[] | null} */
    get result_class() {
        throw new Error("Unimplemented")
    }
    /** @type {?string} */
    get title() {
        throw new Error("Unimplemented")
    }
    /** @type {?number[]} */
    get years() {
        throw new Error("Unimplemented")
    }
}

class DRStatusInitial extends DRStatusGeneral {
    constructor() {
        super()
    }
    get can() {
        return null
    }
    get canBuy() {
        return null
    }
    get can_class() {
        return null
    }
    get connected_to_registrar() {
        return null
    }
    get disabled() {
        return null
    }
    get disableLock() {
        return null
    }
    get discoveredPrice() {
        return null
    }
    get displayInfo() {
        return {
            displayClass: null,
            label: "Loading...",
            labelDisplayClass: null,
            title: null,
        }
    }
    get isFinal() {
        return false
    }
    get label_class() {
        return null
    }
    /** @type {boolean} */
    get loading() {
        return true
    }
    get mainPrices() {
        return null
    }
    get needsDetailCheck() {
        return null
    }
    get pricing() {
        return null
    }
    get product() {
        return null
    }
    get productTLD() {
        return null
    }
    get result_class() {
        return null
    }
    get title() {
        return null
    }
    get years() {
        return null
    }
}

/**
 * @typedef {GET.Services.domain_search.prefix_or_name.output[0]} domainSearchResponse
 */

class DRStatus extends DRStatusGeneral {
    static get canToClassMap() {
        return {
            "premium-register": "register-premium",
            "premium-transfer": "transfer-premium",
            "premium-transfer?": "transfer-premium",
            "premium-transfer-fix": "transfer-premium",
            "register": "register",
            "transfer": "transfer",
            "transfer?": "transfer",
            "transfer-fix": "transfer",
            "transfer-prepare": "transfer",
            "ror-reserved": "ror-reserved",
            "undelete": "transfer",
            "unsupported": "unsupported",
        }
    }
    /**
     *
     * @param {domainSearchResponse} response
     * @param {AnyDomainStore} domainStore
     * @param {AnyBasketInst} basketClient
     */
    constructor(response, domainStore, basketClient, defaultYears = 2) {
        super()
        this.checked = false
        this.in_basket = false
        this.ranDetailedCheck = false

        this.can = response.can
        this.name = response.name
        this.expiryDate = response.expiryDate
        this.hasRight = response.hasRight
        this.maxYears = response.maxYears
        this.push_transfer_registrar = response.push_transfer_registrar
        this.startsNewPeriod = response.startsNewPeriod
        this.response = response
        this.domainStore = domainStore
        this.basketClient = basketClient
        this.nearExpiry = response.nearExpiry
    }
    /**
     * @type {string}
     */
    get can() {
        if(this._can == "register-if-has-right") {
            const right_domain = this.hasRight
            return right_domain && this.domainStore.domainsRegistered.some(
                d => d.toLowerCase() == right_domain.toLowerCase()
            ) ?
                "register" :
                "ror-reserved"
        } else if(this._can == "undelete") {
            const name = this.name
            return name && this.domainStore.domainsCancelled.some(
                d => d.toLowerCase() == name.toLowerCase()
            ) ?
                "undelete" :
                "transfer"
        } else if(
            this._can &&
            this._can.match(/^transfer/) &&
            this.domainStore.domainsRegistered.some(
                d => d.toLowerCase() == this.response.name.toLowerCase()
            )
        ) {
            return "taken"
        } else {
            return this._can
        }
    }
    set can(v) {
        this._can = v
    }
    get canBuy() {
        switch(this.can) {
            case "ror-reserved":
            case "taken":
            case "transfer?":
            case "transfer-fix":
            case "transfer-prepare":
            case "undelete":
            case "unsupported":
                return false
            default:
                return true
        }
    }
    get can_class() {
        return DRStatus.canToClassMap[this.can]
    }
    get connected_to_registrar() {
        return !!this.can
    }
    get disabled() {
        return false
    }
    get disableLock() {
        return !this.canBuy
    }
    get discoveredPrice() {
        const exchange_rate = this.domainStore.exchangeRate
        if(exchange_rate === null) {
            return this.response.price
        } else if(exchange_rate == 1 || !this.response.price) {
            return this.response.price
        } else {
            return Math.round(
                this.response.price * exchange_rate * 100
            ) / 100
        }
    }
    /** @type {{displayClass: string | string[] | null, label: ?string, labelDisplayClass: ?string, title: ?string}} */
    get displayInfo() {
        let display_info
        if(this.can) {
            display_info =
                DRStatus.displayInfoByCan[this.can.replace(/[?]$/, "")] ||
                DRStatus.displayInfoByCan["_default"]
        } else {
            display_info = DRStatus.displayInfoByCan["_null"]
        }
        return Object.assign(
            {},
            display_info,
            {
                title: display_info.title ?
                    display_info.title(this.response) :
                    null
            }
        )
    }
    get isFinal() {
        return true
    }
    get label_class() {
        return this.displayInfo.labelDisplayClass
    }
    get loading() {
        return false
    }
    get mainPrices() {
        if(this.product) {
            return this.product.anyPrice
        } else {
            return null
        }
    }
    get needsDetailCheck() {
        if(this.ranDetailedCheck) return false
        switch(this.can) {
            case "transfer?":
            case "transfer":
                return true
            default:
                return false
        }
    }
    /** @type {?number} */
    get oneYearPrice() {
        if(this.years && this.years.length > 0 && this.product) {
            return this.product.priceForYears(1, this.discoveredPrice)
        } else {
            return null
        }
    }
    /** @type {?string} */
    get oneYearPriceLabel() {
        const p = this.oneYearPrice
        if(p === null) {
            return null
        } else {
            return  this.basketClient.currencySymbol + p.toFixed(2)
        }
    }
    get pricing() {
        if(this.years && this.years.length > 0 && this.product) {
            var c = (this.basketClient && this.basketClient.currencySymbol) ? this.basketClient.currencySymbol : DRStatus.currencySymbol;
            return this.years.map(year => {
                let price = this.product.priceForYears(
                    year,
                    this.discoveredPrice
                )
                return {
                    text: year == 1 ?
                        translation.sprintf(
                            translation.get('dac_parts_price_year_for'),
                            [year, `${c}${price.toFixed(2)}`]
                         ) :
                        translation.sprintf(
                            translation.get('dac_parts_price_years_for'),
                            [year, `${c}${price.toFixed(2)}`]
                        ),
                    id: "" + year
                }
            })
        } else {
            return null
        }
    }
    get product() {
        switch(this.can) {
            case "premium-register":
            case "register":
                if(this.domainStore.productByTld) {
                    return this.domainStore.productByTld[this.productTLD]
                } else {
                    return null
                }
            case "premium-transfer":
            case "premium-transfer?":
            case "transfer?":
            case "transfer":
            case "transfer-fix":
            case "transfer-prepare":
                if(this.domainStore.transferProductByTld) {
                    return this.domainStore.transferProductByTld[
                        this.productTLD
                    ]
                } else {
                    return null
                }

            default:
                return null
        }
    }
    get productTLD() {
        var responseTld = "."+this.response.name.split(".").splice(1).join(".");
        return new DomainResult(
            this.name,
            this.domainStore,
            this.basketClient,
            this.defaultYears
        ) .productTLDs.find((tld) => {
            return responseTld.toLowerCase() == tld.toLowerCase();
        })
    }
    get result_class() {
        return this.displayInfo.displayClass
    }
    /**
     * @deprecated
     * @type {?string}
     */
    get singleYearPrice() {
        const p = this.oneYearPrice
        if(p === null) {
            return null
        } else {
            return p.toFixed(2)
        }
    }
    get title() {
        return this.displayInfo.title
    }
    /** @type {?string} */
    get transferPriceLabel() {
        const p = this.discoveredPrice ? this.discoveredPrice : (this.mainPrices && (this.mainPrices.transfer||this.mainPrices.transfer==0) ? this.mainPrices.transfer : null)
        if(p === null || p === undefined) {
            return this.basketClient.currencySymbol + '0.00'
        } else {
            return this.basketClient.currencySymbol + p.toFixed(2)
        }
    }
    get years() {
        if(this.domainStore.yearsByTld) {
            let max_years = this.response.maxYears
            switch(this.can) {
                case "transfer":
                case "transfer?":
                    max_years = max_years || 1
            }

            if(max_years === undefined) {
                return this.domainStore.yearsByTld[this.productTLD]
            } else if (this.domainStore.yearsByTld[this.productTLD]) {
                return this.domainStore.yearsByTld[this.productTLD]
                    .filter(item => item <= max_years)
            } else {
                return null;
            }
        } else {
            return null
        }
    }
}

DRStatus.currencySymbol = "\u00a3"

/**
 * @type {{[x: string]: {displayClass: string | string[] | null, label: ?string, labelDisplayClass: ?string, title: ?((response: domainSearchResponse) => ?string)}}}
 */
DRStatus.displayInfoByCan = {
    "premium-register":  {
        displayClass: "available premium",
        label: translation.get('dac_parts_add_to_basket_premium'),
        labelDisplayClass: null,
        title: null,
    },
    "premium-transfer": {
        displayClass: "unavailable premium",
        label: translation.get('dac_parts_transfer_in_premium'),
        labelDisplayClass: null,
        title: null,
    },
    "premium-transfer-fix": {
        displayClass: "unavailable premium",
        label: translation.get('dac_parts_locked'),
        labelDisplayClass: "taken",
        title: () => translation.get('dac_parts_locked_cannot_be_transferred'),
    },
    "register": {
        displayClass: "available",
        label: translation.get('dac_parts_add_to_basket'),
        labelDisplayClass: null,
        title: null,
    },
    "transfer": {
        displayClass: "unavailable",
        label: translation.get('dac_parts_transfer_in'),
        labelDisplayClass: null,
        title: null,
    },
    "transfer-fix": {
        displayClass: "unavailable",
        label: translation.get('dac_parts_locked'),
        labelDisplayClass: "taken",
        title: () => translation.get('dac_parts_locked_cannot_be_transferred'),
    },
    "transfer-prepare": {
        displayClass: "unavailable",
        label: translation.get('dac_parts_transfer_in'),
        labelDisplayClass: "taken",
        title: response =>  {
            if(response.name.match(/\.uk$/)) {
                return translation.sprintf(
                    translation.get('dac_parts_is_not_on_our_tag'),
                    [response.push_transfer_registrar]
                )
            } else {
                return translation.get('dac_parts_locked_cannot_be_transferred')
            }
        },
    },
    "recheck": {
        displayClass: "unavailable",
        label: translation.get('dac_parts_please_wait'),
        labelDisplayClass: null,
        title: null,
    },
    "ror-reserved": {
        displayClass: "ror-reserved",
        label: translation.get('dac_parts_reserved'),
        labelDisplayClass: "ror-reserved",
        title: response => translation.sprintf(
            translation.get('dac_parts_reserved_for_the_owner_of_registrar'),
            [response.hasRight]
        ),
    },
    "taken": {
        displayClass: "taken",
        label: translation.get('dac_parts_taken'),
        labelDisplayClass: "taken",
        title: null,
    },
    "undelete": {
        displayClass: "unavailable",
        label: translation.get('dac_parts_undelete'),
        labelDisplayClass: null,
        title: () => translation.get('dac_parts_deleted_can_be_undeleted'),
    },
    "_null": {
        displayClass: ["no-communicate", "unavailable"],
        label: translation.get('dac_parts_could_not_check_availability'),
        labelDisplayClass: "no-communicate",
        title: null,
    },
    "_default": {
        displayClass: null,
        label: null,
        labelDisplayClass: null,
        title: null,
    },
}

class AnyDomainStore {
    constructor() {
        this.baseDomainCategory = domain_categories()
    }
    static get inst() {
        if(!this._inst) {
            this._inst = new this.instClass()
        }
        return this._inst
    }
    /**
     * @param {typeof AnyDomainStore} c
     */
    static register(c) {
        this.instClass = c
    }
    /**
     * @type {?{id: string, name: string, oid: string, pendingTransfer: boolean}[]}
     */
    get domains() {
        throw new Error("Not implemented")
    }
    /**
     * @type {string[]}
     */
    get domainsCancelled() {
        return []
    }
    /**
     * @type {string[]}
     */
    get domainsRegistered() {
        throw new Error("Not implemented")
    }
    /**
     * @type {?number}
     */
    get exchangeRate() {
        return 1
    }
    /**
     * @type {?{[tld: string]: DACDomainProduct}}
     */
    get productByTld() {
        throw new Error("Not implemented")
    }
    /**
     * @type {?{[tld: string]: DACDomainProduct}}
     */
    get transferProductByTld() {
        throw new Error("Not implemented")
    }
    /**
     * @type {?{[x: string]: *}}
     */
    get userInfoGeneral() {
        throw new Error("Not implemented")
    }
    /**
     * @type {?{[tld: string]: number[]}}
     */
    get yearsByTld() {
        throw new Error("Not implemented")
    }
    /**
     * @param {string} name
     * @returns {Promise<boolean>}
     */
    async undelete(name) {
        throw new Error("Not implemented")
    }
}

function mockAjax(options) {
    var that = {
      done: function done(callback) {
        if (options.success)
          setTimeout(callback, options.timeout, options.response);
        return that;
      },
      error: function error(callback) {
        if (!options.success)
          setTimeout(callback, options.timeout, options.response);
        return that;
      }
    };
    return that;
  }

/**
 * Contains info about domain proiducts
 */
class DomainStore extends AnyDomainStore {
    constructor() {
        super()
        this.loaded = {}
        this.loading = {}
        for(let k in this.networkPropertyHandlers) {
            this.loaded[k] = null
            this.loading[k] = null
            Object.defineProperty(this, k, {
                enumerable: true,
                get: () => this.networkProperty(
                    k,
                    this.networkPropertyHandlers[k]
                ),
                set: v => {},
            })
        }
        /**
         * @type {?GET.Services.contract.output}
         */
        this.cancelledDomains = null
        /**
         * @type {?{ [key: string]: string[] }}
         */
        this.domainCategory = null
        /**
         * @type {?{id: string, name: string, oid: string, pendingTransfer: boolean}[]}
         */
        this.domains = null
        /**
         * @type {?{[tld: string]: DACDomainProduct}}
         */
        this.productByTld = null
        /**
         * @type {?{[tld: string]: DACDomainProduct}}
         */
        this.transferProductByTld = null
        /**
         * @type {?{isReseller: boolean}}
         */
        this.userInfoGeneral = null
        /**
         * @type {?{[tld: string]: number[]}}
         */
        this.yearsByTld = null
    }
    static get inst() {
        if(!this._inst) {
            this._inst = new DomainStore()
        }
        return this._inst
    }
    get networkPropertyHandlers() {
        return {
            /**
             * @optional /a/contract
             */
            cancelledDomains: f => $.ajax({
                method: "get",
                url: `${appPrefix}/a/contract`,
                data: {
                    selector: {
                        serviceType: "domain",
                        cancelled: +true,
                    },
                },
                xhrFields: {
                    withCredentials: true
                },
            }).done(f),
            domainCategory: f => $.ajax({
                method: "get",
                url: `${appPrefix}/a/domainCategory`,
                xhrFields: {
                    withCredentials: true
                },
            }).done(res => {
                if (!res || !res.length) return f(this.baseDomainCategory)

                const result = res.reduce((categories, val) => {
                    categories[val.CategoryName] = val.Content.length ? val.Content.split(',') : []
                    return categories
                }, {})

                return f({ ...this.baseDomainCategory, ...result })
            }),
            /** @optional /o/domain */
            domains: f => $.ajax({
                method: "get",
                url: `${appPrefix}/o/domain`,
                xhrFields: {
                    withCredentials: true
                },
            }).done(f),
            productByTld: f => $.ajax({
                method: "GET",
                url: `${appPrefix}/a/product/domain/new`,
                xhrFields: {
                    withCredentials: true
                }
            }).done(
                products => {
                    let ps = {}
                    for(let k in products) {
                        ps[k] = new DACDomainProduct(products[k],this)
                    }
                    f(ps)
                }
            ),
            transferProductByTld: f => $.ajax(`${appPrefix}/a/product/domain/transfer`).done(
                products => {
                    let ps = {}
                    for(let k in products) {
                        ps[k] = new DACDomainProduct(products[k],this)
                    }
                    f(ps)
                }
            ),
            userInfoGeneral: f => $.ajax({
                method: "get",
                url: `${appPrefix}/a/user-info`,
                dataType: "json",
                xhrFields: {
                    withCredentials: true
                },
            }).done(f),
            yearsByTld: f => $.ajax(`${appPrefix}/a/domain-period`).done(f),
        }
    }
    networkProperty(n, f) {
        if(!this.loaded[n]) {
            if(!this.loading[n]) {
                this.loading[n] = true
                this.loaded[n] = null
                f(result => this.loaded[n] = result)
            }
        }
        return this.loaded[n]
    }
    preload(names) {
        let waiting = 0
        names.forEach(name => {
            if(this.networkPropertyHandlers[name] && !this[name]) {
                waiting++
            }
        })
        return waiting
    }
    get domainsCancelled() {
        if(!appPrefix || location.href.startsWith(appPrefix)) {
            if(this.cancelledDomains) {
                return this.cancelledDomains.map(
                    datum => datum.serviceName
                ).filter(name => name)
            } else {
                return []
            }
        } else {
            return []
        }
    }
    get domainsRegistered() {
        if(!appPrefix || location.href.startsWith(appPrefix)) {
            if(this.domains) {
                return this.domains.filter(
                    datum => !datum.pendingTransfer
                ).map(datum => datum.name)
            } else {
                return []
            }
        } else {
            return []
        }
    }
    get pricingType() {
        if(this.userInfoGeneral) {
            return this.userInfoGeneral.isReseller ?
                "reseller" :
                "non_reseller"
        } else {
            return "non_reseller"
        }
    }
    /**
     * @param {string} name
     * @returns {Promise<boolean>}
     */
    async undelete(name) {
        return await $.ajax({
            method: "post",
            url: `${appPrefix}/a/provision/undelete`,
            data: {
                name: name,
                type: "domain",
            },
        })
    }

    get userInfo() {
        return this.userInfoGeneral;
    }
}

AnyDomainStore.register(DomainStore)
